/**
 * Centrale slider dots initialisatie
 * Werkt voor alle sliders: header, product sliders, etc.
 */

(function() {
  'use strict';
  
  function initSliderDots() {
  // Alle slider containers en hun configuraties
  const sliderConfigs = [
    // Header sliders (zowel met als zonder .mobile-slider class)
    {
      containerSelector: '.bento-header-cards-grid.mobile-slider, .bento-header-cards-grid--sidebar-layout',
      dotsSelector: '.mobile-dots',
      itemSelector: '.bento-header-card',
      dotClass: 'mobile-dot',
      breakpoint: 980,
      itemsPerView: (width) => width >= 640 ? 2 : 1,
      scrollMethod: 'fraction' // gebruikt scroll-fraction berekening
    },
    // Product sliders
    {
      containerSelector: '.products-slider__container',
      dotsSelector: '.products-slider__mobile-dots',
      itemSelector: '.product-slide',
      dotClass: 'products-slider__mobile-dot',
      breakpoint: 600,
      itemsPerView: () => 2,
      scrollMethod: 'slide-width' // gebruikt slide-width berekening
    },
    // Product highlights
    {
      containerSelector: '.product-cards-grid.mobile-slider',
      dotsSelector: '.mobile-dots',
      itemSelector: '.product-card',
      dotClass: 'mobile-dot',
      breakpoint: 768,
      itemsPerView: () => 1,
      scrollMethod: 'slide-width'
    },
    // Mijn huisdieren
    {
      containerSelector: '.mijn-huisdieren__container',
      dotsSelector: '.mijn-huisdieren__mobile-dots',
      itemSelector: '.pet-slide',
      dotClass: 'mobile-dot',
      breakpoint: 769,
      itemsPerView: () => 1,
      scrollMethod: 'slide-width'
    }
  ];

  sliderConfigs.forEach(config => {
    const containers = document.querySelectorAll(config.containerSelector);
    
    containers.forEach(container => {
      const sliderId = container.id || `slider-${Math.random().toString(36).substr(2, 9)}`;
      if (!container.id) container.id = sliderId;
      
      // Zoek dots container - eerst in section, dan in parent
      const section = container.closest('[id^="shopify-section"]');
      const sectionId = section?.id?.replace('shopify-section-', '');
      
      let dotsContainer = null;
      if (sectionId) {
        // Probeer eerst met data-section-id
        dotsContainer = section.querySelector(`${config.dotsSelector}[data-section-id="${sectionId}"]`) ||
                       section.querySelector(config.dotsSelector);
      }
      
      if (!dotsContainer) {
        dotsContainer = container.parentElement?.querySelector(config.dotsSelector);
      }
      
      if (!dotsContainer) return;
      
      let scrollHandler = null;
      let lastActiveDotIndex = 0; // Onthoudt de laatst actieve dot
      let isUserInteracting = false; // Volgt of gebruiker actief met slider bezig is
      let interactionTimeout = null;
      let lastScrollLeft = 0; // Onthoudt laatste scroll positie om onnodige updates te voorkomen
      
      const createDots = () => {
        const items = Array.from(container.querySelectorAll(config.itemSelector))
          .filter(item => item.style.display !== 'none' && item.offsetParent !== null);
        
        if (items.length <= 1) {
          dotsContainer.style.display = 'none';
          if (scrollHandler) {
            container.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
          }
          return;
        }
        
        const width = window.innerWidth;
        if (width >= config.breakpoint) {
          dotsContainer.style.display = 'none';
          if (scrollHandler) {
            container.removeEventListener('scroll', scrollHandler);
            scrollHandler = null;
          }
          return;
        }
        
        const itemsPerView = typeof config.itemsPerView === 'function' 
          ? config.itemsPerView(width) 
          : config.itemsPerView;
        
        const numberOfDots = Math.ceil(items.length / itemsPerView);
        
        dotsContainer.innerHTML = '';
        dotsContainer.style.display = 'flex';
        
        // Reset tracking bij nieuwe dots
        lastActiveDotIndex = 0;
        lastScrollLeft = container.scrollLeft; // Sla huidige scroll positie op
        
        for (let i = 0; i < numberOfDots; i++) {
          const dot = document.createElement('div');
          dot.className = config.dotClass + (i === 0 ? ' active' : '');
          dot.setAttribute('data-slider-id', sliderId);
          
          dot.addEventListener('click', () => {
            isUserInteracting = true;
            clearTimeout(interactionTimeout);
            interactionTimeout = setTimeout(() => { isUserInteracting = false; }, 500);
            
            const targetIndex = i * itemsPerView;
            if (items[targetIndex]) {
              items[targetIndex].scrollIntoView({ 
                behavior: 'smooth', 
                block: 'nearest', 
                inline: 'center' 
              });
            }
          });
          
          dotsContainer.appendChild(dot);
        }
        
        // Track user interaction (touch/mouse)
        container.addEventListener('touchstart', () => {
          isUserInteracting = true;
          clearTimeout(interactionTimeout);
        }, { passive: true });
        
        container.addEventListener('touchend', () => {
          // Blijf even actief na touch voor scroll momentum
          clearTimeout(interactionTimeout);
          interactionTimeout = setTimeout(() => { isUserInteracting = false; }, 500);
        }, { passive: true });
        
        container.addEventListener('mousedown', () => {
          isUserInteracting = true;
          clearTimeout(interactionTimeout);
        });
        
        container.addEventListener('mouseup', () => {
          clearTimeout(interactionTimeout);
          interactionTimeout = setTimeout(() => { isUserInteracting = false; }, 500);
        });
        
        // Setup scroll handler
        if (scrollHandler) {
          container.removeEventListener('scroll', scrollHandler);
        }
        
        const updateDots = (dotIndex) => {
          if (dotIndex !== lastActiveDotIndex) {
            lastActiveDotIndex = dotIndex;
            dotsContainer.querySelectorAll(`.${config.dotClass}[data-slider-id="${sliderId}"]`).forEach((dot, index) => {
              dot.classList.toggle('active', index === dotIndex);
            });
          }
        };
        
        if (config.scrollMethod === 'fraction') {
          // Header methode: scroll-fraction
          scrollHandler = () => {
            const currentScrollLeft = container.scrollLeft;
            
            // Negeer als scroll positie niet significant veranderd is (minder dan 5px)
            // Dit voorkomt updates bij kleine layout shifts tijdens verticaal scrollen
            const scrollDelta = Math.abs(currentScrollLeft - lastScrollLeft);
            if (scrollDelta < 5) {
              return;
            }
            
            // Als er een significante horizontale scroll is, update altijd de dots
            // Dit werkt ook bij trackpad/muiswiel scrollen waar touchstart/mousedown niet altijd getriggerd wordt
            lastScrollLeft = currentScrollLeft;
            
            const maxScroll = container.scrollWidth - container.clientWidth;
            const fraction = maxScroll > 0 ? currentScrollLeft / maxScroll : 0;
            const dotIndex = Math.min(numberOfDots - 1, Math.round(fraction * (numberOfDots - 1)));
            
            updateDots(dotIndex);
          };
        } else {
          // Product slider methode: slide-width
          scrollHandler = () => {
            const currentScrollLeft = container.scrollLeft;
            
            // Negeer als scroll positie niet significant veranderd is (minder dan 5px)
            // Dit voorkomt updates bij kleine layout shifts tijdens verticaal scrollen
            const scrollDelta = Math.abs(currentScrollLeft - lastScrollLeft);
            if (scrollDelta < 5) {
              return;
            }
            
            // Als er een significante horizontale scroll is, update altijd de dots
            // Dit werkt ook bij trackpad/muiswiel scrollen waar touchstart/mousedown niet altijd getriggerd wordt
            lastScrollLeft = currentScrollLeft;
            
            const visibleItems = Array.from(container.querySelectorAll(config.itemSelector))
              .filter(item => item.style.display !== 'none' && item.offsetParent !== null);
            
            if (visibleItems.length === 0) return;
            
            const gap = 8;
            const itemWidth = visibleItems[0].offsetWidth + gap;
            const activeIndex = Math.round(currentScrollLeft / itemWidth);
            const dotIndex = Math.min(Math.floor(activeIndex / itemsPerView), numberOfDots - 1);
            
            updateDots(dotIndex);
          };
        }
        
        container.addEventListener('scroll', scrollHandler);
      };
      
      // Initial create
      createDots();
      
      // Update bij resize - alleen als breedte echt verandert
      let resizeTimeout;
      let lastWidth = window.innerWidth;
      const resizeHandler = () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const currentWidth = window.innerWidth;
          // Alleen recreëren als breedte significant veranderd is (minimaal 50px verschil)
          // Dit voorkomt onnodige resets bij kleine scroll events
          if (Math.abs(currentWidth - lastWidth) >= 50) {
            lastWidth = currentWidth;
            createDots();
          }
        }, 150);
      };
      
      window.addEventListener('resize', resizeHandler);
      
      // Cleanup functie voor theme editor
      container.setAttribute('data-dots-initialized', 'true');
    });
  });
}

    // Export voor gebruik in init-globals.js
    if (typeof theme !== 'undefined') {
      theme.initSliderDots = initSliderDots;
    }
    
    // Auto-init bij DOMContentLoaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSliderDots);
    } else {
      initSliderDots();
    }
    
    // Re-init bij section load (Shopify theme editor)
    document.addEventListener('shopify:section:load', initSliderDots);
    document.addEventListener('shopify:section:reorder', initSliderDots);
  })();

